import React from 'react';
import { CircularProgress } from '@material-ui/core/';
import styled from 'styled-components/macro';

const LoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 5rem;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const Loader = () => {
  return (
    <LoaderWrapper>
      <CircularProgress size={80} color="primary" />
    </LoaderWrapper>
  );
};

export default Loader;
